import type { HTMLAttributes } from "react";

export function Card({
  className = "",
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`bg-bg-card border border-border-default rounded-xl p-5 ${className}`}
      {...rest}
    />
  );
}
